package com.iregained.eventapp.components.sections.event_booking.sections

import androidx.compose.runtime.Composable
import com.iregained.eventapp.components.sections.event_booking.styles.CardContainerStyle
import com.iregained.eventapp.theme.toSitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.px

@Composable
fun EventConfirmationSection(
    patientName: String, accessToken: String, slotTime: String
) {
    val palette = ColorMode.current.toSitePalette()
    val manageUrl = "https://event.iregained.rehab/manage?token=$accessToken"

    Column(
        modifier = CardContainerStyle.toModifier().backgroundColor(palette.custom.cardBackground)
            .margin(topBottom = 30.px), horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SpanText(
            text = "🎉 Booking Confirmed!",
            modifier = Modifier
                .fontSize(28.px)
                .fontWeight(FontWeight.Bold)
                // Swapped accentGreen for brandPrimary
                .color(palette.custom.brandPrimary)
                .margin(bottom = 12.px)
        )
        SpanText(
            text = "Thank you $patientName. Your session has been reserved for $slotTime.",
            modifier = Modifier.fontSize(16.px).margin(bottom = 20.px)
        )

        SpanText(
            text = "Self-Service Management Link:",
            modifier = Modifier.fontWeight(FontWeight.Bold).margin(bottom = 4.px)
        )
        Link(
            path = manageUrl, text = manageUrl, modifier = Modifier.margin(bottom = 16.px)
        )

        SpanText(
            text = "A confirmation email with calendar invite (.ics) has been dispatched.",
            modifier = Modifier.fontSize(14.px)
        )
    }
}